import axios from 'axios';
import { useEffect, useState } from 'react';
import './Feedback.css';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

const Feedback = () => {
    const [feedbackList, setFeedbackList] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        fetchFeedback();
    }, []);

    const fetchFeedback = async () => {
        try {
            setIsLoading(true);
            setErrorMessage('');
            const response = await axios.get(`${BASE_URL}/loadFeedbacks.php`);
            
            if (response.data && response.data.feedback) {
                setFeedbackList(response.data.feedback);
            } else {
                throw new Error('Invalid response format');
            }
        } catch (error) {
            console.error('Feedback fetch error:', error);
            setErrorMessage(
                error.response?.data?.message || 
                'Failed to fetch feedback. Please try again.'
            );
        } finally {
            setIsLoading(false);
        }
    };

    const deleteFeedback = async (feedbackId) => {
        if (!window.confirm('Are you sure you want to delete this feedback?')) {
            return;
        }

        try {
            setIsDeleting(true);
            setErrorMessage('');
            
            await axios.put(`${BASE_URL}/deleteFeedback.php`, { feedbackId });
            
            setFeedbackList(prevList => 
                prevList.filter(feedback => feedback.feedbackId !== feedbackId)
            );
        } catch (error) {
            console.error('Feedback deletion error:', error);
            setErrorMessage(
                error.response?.data?.message || 
                'Failed to delete feedback. Please try again.'
            );
        } finally {
            setIsDeleting(false);
        }
    };

    const renderFeedbackItem = (feedback) => (
        <div
            key={feedback.feedbackId}
            className={`feedback-module-item ${feedback.isRead ? 'read' : ''}`}
        >
            <div className="feedback-module-header">
                <span className="feedback-module-name">
                    {feedback.name || 'Anonymous'}
                </span>
                <span>
                    {feedback.createdAt}
                </span>
                <button
                    className="feedback-module-btn delete-btn"
                    onClick={() => deleteFeedback(feedback.feedbackId)}
                    disabled={isDeleting}
                >
                    {isDeleting ? 'Deleting...' : 'Delete'}
                </button>
            </div>
            <p className="feedback-module-message">
                {feedback.message}
            </p>
        </div>
    );

    const renderContent = () => {
        if (isLoading) {
            return <p className="feedback-loading">Loading feedback...</p>;
        }

        if (errorMessage) {
            return <p className="feedback-error-message">{errorMessage}</p>;
        }

        if (feedbackList.length === 0) {
            return <p className="feedback-empty">No feedback available.</p>;
        }

        return (
            <div className="feedback-module-list">
                {feedbackList.map(renderFeedbackItem)}
            </div>
        );
    };

    return (
        <div className="feedback-module-container">
            <h2>Customer Feedback</h2>
            {renderContent()}
        </div>
    );
};

export default Feedback;